import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'iptracking',
    components: {
        Paginate,
        VueElementLoading,
        Multiselect
    },
    data: function() {
        return {
          trackname : (!(window.localStorage.getItem("LSTrackname")) || (window.localStorage.getItem("LSTrackname")) == 'undefined') ? ""  : window.localStorage.getItem('LSTrackname'),
          remoteurl : (!(window.localStorage.getItem("LSRemoteurl"))|| (window.localStorage.getItem("LSRemoteurl")) == 'undefined') ? ""  : window.localStorage.getItem('LSRemoteurl'),
          userid : (!(window.localStorage.getItem("LSUserid"))|| (window.localStorage.getItem("LSUserid")) == 'undefined') ? ""  : window.localStorage.getItem('LSUserid'),
          username : (!(window.localStorage.getItem("LSUname"))|| (window.localStorage.getItem("LSUname")) == 'undefined') ? ""  : window.localStorage.getItem('LSUname'),
          isLoading : false,
          isLoader : false,
          ishubloader : false,
          istrackloader : false,
          pagecount : 1,
          pageno : 0,
          resultCount : '',
          listUserData : [],
          locationDetails : [],
          hubid:'',
          hubServiceCenterList:[],
          listTrackData:[],
          datefilter: '',
          logdetailsmodal: false,
          locationModal: false,
          logrowdata: {},
          isLocationLoading: false,
          tempArrKey : [],
          tempArrVal : [],
          accessHubList : []
        }
    },
    created: function() {
    },
    mounted() {
      var userdetailEncrypt = window.localStorage.getItem('userdetail')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.localuserid = userdetail.userid;
      this.localusermailid = userdetail.email;
      this.pageno = 0;
      this.getUserAccessDetail();
      this.getHubServiceCenterData();
      this.getTrackNames();
    },
    methods: {
      getHubServiceCenterData() {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');

        this.input = {}
        this.ishubloader = true;
        axios({
            method: 'GET',
            url: apiUrl.api_url + 'external/gethubservicecenterlist',
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then(result => {
            var data = [];
            result.data.hubs.data.forEach(function (hubData) {
              data.push({
                id:hubData.HubID,
                label:hubData.HubName
              });
            });
            this.hubServiceCenterList = data;
            this.ishubloader = false
          }, error => {
            console.error(error)
          })
      },
      showDetails(id){
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input={
          id: id
        }
        this.tempArrKey=[]
        this.tempArrVal=[]
        this.logdetailsmodal = true
        this.isLoader = true
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'getlogdetails',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        }).then(result=>{
          let jsonMeta = {}
          this.logrowdata = result.data
          jsonMeta = this.logrowdata.meta
          var x;
          for(x in jsonMeta){
            this.tempArrKey.push(x)
            this.tempArrVal.push(jsonMeta[x])
          }
          this.accessHubList = this.getHubNameList(this.logrowdata.HubId,this.hubServiceCenterList)
          this.isLoader = false
        })
      },
      closemodal(){
        this.logdetailsmodal = false
      },
      getUserAccessDetail(){
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input={
          offset: this.pageno,
          limit: 10,
          trackname: this.trackname.label,
          remoteurl: this.remoteurl,
          userid: this.userid,
          createddate: this.datefilter
        }
        window.localStorage.setItem("LSTrackname",this.trackname)
        window.localStorage.setItem("LSRemoteurl",this.remoteurl)
        window.localStorage.setItem("LSUserid",this.userid)
        this.isLoading = true;
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'getuseraccesstracklogs',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        }).then(result=>{
          this.listUserData = result.data.rows;
          for (var i = 0; i < this.listUserData.length; i++) {
            this.listUserData[i].createddate = this.formatDateTime(this.listUserData[i].createddate)
          }
          this.isLoading = false;
          let totalRows = result.data.count
          this.resultCount = result.data.count
          if (totalRows < 10) {
              this.pagecount = 1
          } else {
              this.pagecount = Math.ceil(totalRows / 10)
          }
        })
      },
      searchUserData() {
        this.pageno = 0;
        this.$refs.paginate.selected = 0;
        this.getUserAccessDetail();
      },
      resetForm(){
        this.trackname=''
        this.remoteurl=''
        this.trackname=''
        this.userid=''
        this.username=''
        this.datefilter=''
        this.hubid = ''
        this.pageno = 0;
        this.getUserAccessDetail();
      },
      getPaginationData(pageNum){
        this.pageno = (pageNum - 1) * 10
        this.getUserAccessDetail()
      },

      formatDateTime(date){
        date = new Date(date)
        let gmtDate = date
          .toISOString()
          .replace(/T/, " ")
          .replace(/\..+/, "");
        return gmtDate;
      },
      getLatLong(ip){
        ip = ip.trim()
        this.locationModal = true
        this.isLocationLoading = true
        axios({
          method: 'GET',
          url: 'http://ip-api.com/json/'+ip,

        }).then(result=>{
          this.locationDetails = result.data

          this.displayMap(this.locationDetails.lon,this.locationDetails.lat)
        })
      },
      closeLocationModal(){
        this.locationModal = false
      },
      displayMap(long,lat){
        mapboxgl.accessToken = apiUrl.mapKey
        var map = new mapboxgl.Map({
        container: 'map', // container id
        style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        center: [long, lat], // starting position [lng, lat]
        zoom: 13 // starting zoom
        });
        var marker = new mapboxgl.Marker({color: 'red'})
        .setLngLat([long, lat])
        .addTo(map);
        this.isLocationLoading = false
      },
      getTrackNames() {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        window.localStorage.setItem("LSProjectName",this.searchprojectname)
        this.istrackloader = true
        this.input = ({
          offset: this.pageno,
          limit: 10,
          projectname: this.searchprojectname
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getprojectlist',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then(result => {
            let data = []

            result.data.data.rows.forEach(function (trackData) {
              data.push({
                label:trackData.projectname
              });
            });
            this.listTrackData = data;
            this.istrackloader = false
          }, error => {
            console.error(error)
          })
        },
        getHubNameList(hubArray,hublist){
          let hubNameArray = []
          if(hubArray){
            if(hubArray.length > 0){
              for(var j = 0; j < hubArray.length; j++){
                for (var i = 0; i < hublist.length; i++) {
                  if(hubArray[j] == hublist[i].id){
                    hubNameArray.push(hublist[i].label)
                  }
                }
              }
              return (hubNameArray)
            }
            else {
              return null
            }
          }
          }

    }
}



// WEBPACK FOOTER //
// ./src/views/components/iptracking/iptracking.component.js